var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.05029,
    cy: 7.99316,
    r: 8,
    fill: "#17CB34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29029 5.62316C8.11696 5.62316 7.97029 5.56316 7.85029 5.44316C7.73029 5.32316 7.67029 5.1765 7.67029 5.00316C7.67029 4.82983 7.73029 4.68316 7.85029 4.56316C7.97029 4.44316 8.11696 4.38316 8.29029 4.38316C8.45696 4.38316 8.59696 4.44316 8.71029 4.56316C8.83029 4.68316 8.89029 4.82983 8.89029 5.00316C8.89029 5.1765 8.83029 5.32316 8.71029 5.44316C8.59696 5.56316 8.45696 5.62316 8.29029 5.62316ZM8.73029 6.51316V11.9932H7.82029V6.51316H8.73029Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.a371fe2c1e0fa1ed3562a3a42173bbba.svg";
export { ForwardRef as ReactComponent };